import {
  getAPIGatewayDataFromParent,
  getTcpRoles,
  getUserLoginFromParent,
  getUserNameFromParent
} from "../handler/ParentDataHandler";
import {AMAZON_SUFFIX, ENDPOINT_AUTH, TIMEOUT_STRING} from "../util/Constants";
import {getAPIGatewayGetRequest} from "../util/Util";

export async function getUserName() {
  let response = await getUserLoginFromParent()
  if (response === TIMEOUT_STRING) {
    response = await getUserNameFromParent()
  }
  let userName = JSON.parse(response.name)
  if (!userName.endsWith(AMAZON_SUFFIX)) {
    userName += AMAZON_SUFFIX;
  }
  return userName;
}

export async function getEmployeeTCPRoles() {
  let response = await getTcpRoles();
  return JSON.parse(response.roles);
}

export async function getEmployeePermission() {
  const parent_response = await getAPIGatewayDataFromParent(getAPIGatewayGetRequest(ENDPOINT_AUTH));
  return parent_response.data.isAuthorized;
}



// WEBPACK FOOTER //
// ./src/components/resources/EmployeeResource.js